module.exports = __webpack_public_path__ + "2e99b4f2b97b2c953dcd42082487a3ce.svg";